import React, { PureComponent } from "react";

class Moneda extends PureComponent {

    render() {
        
        const { tipoMoneda, seleccionarMoneda, monedaId } = this.props;

        const optionMoneda = tipoMoneda.map((moneda, index) => {
            return (
                <option key={"moneda-opt" + index} value={moneda.ID}>
                    {moneda.DESCRIPCION}
                </option>
            );
        });

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-5">
                    <label className="label-primary">Moneda</label>
                    <select className="form-control default-select" value={monedaId}
                        onChange={(event) => {
                            seleccionarMoneda(event.target.value)
                        }}>
                        {optionMoneda}
                    </select>
                </div>
            </div>
        );

    }

}

export default Moneda;